// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext, useContext } from 'react';
const TableComponentsContext = createContext(null);
export const TableComponentsContextProvider = TableComponentsContext.Provider;
export const useTableComponentsContext = () => {
    const tableComponentContext = useContext(TableComponentsContext);
    return tableComponentContext;
};
//# sourceMappingURL=table-component-context.js.map